'use client';
import { useEffect, useState } from 'react';

import { Ad } from '@ads/Components/Ad/Ad';
import { buildPlpTargeting } from '@ads/Utils/BuildPlpTargeting';
import { isWindowDefined } from '@core/Constants/Window';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

import styles from './AdsPanel.module.css';

export const AdsPanelClient = ({ filters }: { filters: Filter[] }) => {
  const [shouldShowAds, setShouldShowAds] = useState(false);

  useEffect(() => {
    if (isWindowDefined) {
      setShouldShowAds(true);
    }
  }, []);

  const plpAdTargeting = buildPlpTargeting(filters);

  return (
    <>
      {shouldShowAds && plpAdTargeting ? (
        <div className={styles.panelAds}>
          <Ad unitId="plpDmpu1" targeting={plpAdTargeting} stickyPadding={500} />
          <div className={styles.plpDmpuAdContainer}>
            <div className={styles.plpDmpuAd}>
              <Ad unitId="plpDmpu2" targeting={plpAdTargeting} withMargin />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
